// Core
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Styles
import "./styles.scss";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getAssessmentsSubmittedByCompaniesRequest_ACCESSOR,
  getDashboardBacklogCountsRequest_ACCESSOR,
  getAssessmentTrackerListRequest_ACCESSOR,
} from "../../../../Redux/Slices/Accessor/accessorSlice";

// Svg icons
import newRequestIcon from "../../../../Assets/Images/newRequestIcon.svg";
import inprogressRequestIcon from "../../../../Assets/Images/inprogressRequestIcon.svg";
import completeRequestIcon from "../../../../Assets/Images/completeRequestIcon.svg";

// Custom components
import MainLayout from "Layouts/Main";
import CustomSelect from "Components/CustomSelect";
import LineChart from "Components/Charts";
import NormalTable from "Components/NormalTable";
import moment from "moment";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Dashboard = () => {
  //Initialize redux
  const dispatch = useDispatch();

  // Initialize useNavigate
  const navigate = useNavigate();

  const [sort, setSort] = useState({ sortBy: null, sortOrder: 0 });
  const [selectedFilter, setSelectedFilter] = useState("weekly");
  const [numberOfBacklogs, setNumberOfBacklogs] = useState("");
  const [inProgressBacklogs, setInProgressBacklogs] = useState("");
  const [completedBacklogs, setCompletedBacklogs] = useState("");
  const [assessmentsSubmittedByCompanies, setAssessmentsSubmittedByCompanies] =
    useState({});
  const [data, setData] = useState([]);
  const isLoading = useSelector((state) => state.accessor.isLoading);

  const filterOptions = [
    { label: "Last Week", value: "weekly" },
    { label: "Last Six Month", value: "lastsixmonth" },
    { label: "Last Year", value: "lastyear" },
  ];

  const filterStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #464646",
      borderRadius: "6px",
      padding: "4px",
      boxShadow: "none",
      width: "237px",
      minHeight: "44px",
      height: "42px",
      cursor: "pointer",
      boxShadow: "4px 4px 8px rgba(0, 0, 0, 0.1)",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#1F2155"
        : state.isFocused
        ? "#e9ecef"
        : "#fff",
      color: state.isSelected ? "#fff" : "#000",
      padding: 10,
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#1F2155"
          : state.isFocused
          ? "#e9ecef"
          : "#fff",
        color: state.isSelected ? "#fff" : "#000",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000000",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#121212",
      padding: "0 8px",
    }),
  };

  const assessmentReviewHeaders = [
    { label: "S.No", isSort: false, key: "sno" },
    { label: "Company Name", isSort: false, key: "company_name" },
    { label: "Assessment Name", isSort: false, key: "assessment_name" },
    {
      label: "Assessment Creation Date",
      isSort: false,
      key: "createdAt",
    },

    {
      label: "Pre-assessment Due Date",
      isSort: false,
      key: "due_date",
    },
    { label: "Status", isSort: false, key: "status" },
  ];

  useEffect(() => {
    baseApiCalls();
  }, [selectedFilter]);

  const baseApiCalls = async () => {
    // To get the top 3 count of dashboard
    await dispatch(
      getDashboardBacklogCountsRequest_ACCESSOR({
        period: selectedFilter,
        callBack: getDashboardBacklogCountsRequestCB_ACCESSOR,
      })
    );

    await dispatch(
      getAssessmentsSubmittedByCompaniesRequest_ACCESSOR({
        period: selectedFilter,
        callBack: getAssessmentsSubmittedByCompaniesRequestCB_ACCESSOR,
      })
    );
  };

  //To handle the response of getDashboardBacklogCountsRequest_ACCESSOR
  const getDashboardBacklogCountsRequestCB_ACCESSOR = (data) => {
    setNumberOfBacklogs(data?.totalBacklogs);
    setInProgressBacklogs(data?.inProgressBacklogs);
    setCompletedBacklogs(data?.completedBacklogs);
  };

  //To handle the response of getAssessmentsSubmittedByCompaniesRequest_ACCESSOR
  const getAssessmentsSubmittedByCompaniesRequestCB_ACCESSOR = (data) => {
    setAssessmentsSubmittedByCompanies(data);
  };

  useEffect(() => {
    getAssessmentTrackerListRequest_ACCESSOR_();
  }, [sort]);

  const getAssessmentTrackerListRequest_ACCESSOR_ = () => {
    dispatch(
      getAssessmentTrackerListRequest_ACCESSOR({
        page: 1,
        sortBy: sort.sortOrder === 1 ? "ASC" : "DESC",
        orderBy: sort.sortBy,
        callBack: getAssessmentTrackerListRequestCB_ACCESSOR,
      })
    );
  };

  const getAssessmentTrackerListRequestCB_ACCESSOR = (data) => {
    setData(data?.data?.data);
  };

  return (
    <MainLayout>
      <div className="assessor-dashboard-container ps-4 ms-2">
        <div className="assessor-dashboard-heading">
          <div className="dashboardLabel">Dashboard Overview</div>
          <div className="row justify-content-end mx-4 pr-3">
            <CustomSelect
              defaultValue={filterOptions?.[0]}
              options={filterOptions}
              customStyles={filterStyles}
              placeholder="Select Filter"
              onChange={(data) => {
                setSelectedFilter(data?.value);
              }}
            />
          </div>
        </div>
        {isLoading === 'loading' ? (
          <div style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}>
            <Skeleton height={120} width={300} style={{ marginTop: "20px" }} />
            <Skeleton height={120} width={300} style={{ marginTop: "20px" }} />
            <Skeleton height={120} width={300} style={{ marginTop: "20px" }} />
          </div>
            ) : (
        <div className="dashboardCardWrap mt-4">
          <div className="newRequestCard">
            <div className="row align-items-center py-2">
              <div className="col-7 ps-4">
                <div className="newRequestCount">{numberOfBacklogs}</div>
                <div className="dashboardCardLabel">
                  Total Number of Assessment
                  {/* Backlogs */}
                </div>
              </div>
              <div className="col-5">
                <img
                  src={newRequestIcon}
                  alt="icon"
                  className="dashboardIcon"
                />
              </div>
            </div>
          </div>
          <div className="inprogressRequestCard">
            <div className="row align-items-center py-2">
              <div className="col-8 ps-4">
                <div className="inprogressRequestCount">
                  {inProgressBacklogs}
                </div>
                <div className="dashboardCardLabel">
                  In-Progress Assessment 
                  {/* Backlog */}
                </div>
              </div>
              <div className="col-4">
                <img
                  src={inprogressRequestIcon}
                  alt="icon"
                  className="dashboardIcon"
                />
              </div>
            </div>
          </div>
          <div className="completedRequestCard">
            <div className="row align-items-center py-2">
              <div className="col-8 ps-4">
                <div className="completeRequestCount">{completedBacklogs}</div>
                <div className="dashboardCardLabel">
                  Completed Assessment 
                  {/* Backlog */}
                </div>
              </div>
              <div className="col-4">
                <img
                  src={completeRequestIcon}
                  alt="icon"
                  className="dashboardIcon"
                />
              </div>
            </div>
          </div>
        </div> )}
        <div className=" my-4">
          <div className="">
            <div className="chartTitle">
              Pre - Assessments Submitted by Companies
            </div>
            <LineChart
              chartData={assessmentsSubmittedByCompanies}
              // width="100%"
              xAxisColor="#718EBF"
              yAxisColor="#718EBF"
            />
          </div>
        </div>
        <div>
          {data?.length > 0 && (
            <div className="d-flex justify-content-between">
              <label className="chartTitle">Assessments Tracker</label>
              <div
                onClick={() => navigate("/assessment-tracker")}
                className="viewAllLabel py-2 me-5"
              >
                View All
              </div>
            </div>
          )}
          <div>
            <NormalTable
              headers={assessmentReviewHeaders}
              sort={sort}
              setSort={setSort}
              currentPage={1}
              noDataColspan={9}
              totalPages={1}
              customStyle={{
                customTableHeaderContainer: "customDashboardTableHeader",
                customHeaderTitle: "customDashboardHeaderTitle",
                customTable: "customDashboardTable",
                customTableContainer: "customDashboardTableContainer",
              }}
              noDataLabel={data?.length === 0}
            >
              {data?.map((item, index) => {
                const statusClassName =
                  item.status === 3
                    ? "dashboard-completedStatus"
                    : item?.status === 2
                    ? "dashboard-inProgressStatus"
                    : "dashboard-progressStatus";

                return (
                  <tr key={index}>
                    <td>
                      <div className="DashboardTableDivision">{index + 1}</div>
                    </td>
                    <td>
                      <div className="DashboardTableDivision">
                        {item?.company_name ?? "-"}
                      </div>
                    </td>
                    <td>
                      <div className="DashboardTableDivision">
                        {item?.assessment_name ?? "-"}
                      </div>
                    </td>
                    <td>
                      <div className="DashboardTableDivision">
                        {!!item?.createdAt
                          ? moment(item?.createdAt).format("DD/MM/YYYY")
                          : "-"}
                      </div>
                    </td>

                    <td>
                      <div className="DashboardTableDivision flex-column">
                        {!!item?.due_date
                          ? moment(item?.due_date).format("DD/MM/YYYY")
                          : "-"}
                      </div>
                    </td>

                    <td>
                      <div
                        className={`DashboardTableDivision ${statusClassName} ms-5`}
                      >
                        {item?.status === 3
                          ? "Completed"
                          : item?.status === 2
                          ? "InProgress"
                          : "Pending"}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </NormalTable>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
